/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as statusActions from 'actions/statusActions';
import * as userActions from 'actions/userActions';
import * as workOrderActions from 'actions/workOrderActions';
import * as techInventoryActions from 'actions/techInventoryActions';

import Footer from 'containers/Footer';

export class TechAdminPage extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {

        const {user} = this.props;

        const isFieldAdmin = user.get('isFieldAdmin');

        if (!isFieldAdmin) {
            return (
                <h5>You do not have access to this page. Please create a ticket and request
                    field admin access.</h5>
            );
        }

        const channels = user.getIn(['channelData', 'channels']);
        const sections = [];

        if (channels) {
            channels.forEach((channel, index) => {

                sections.push((
                    <div key={`channel_${index}`}>
                        <h5>{channel.get('name')}</h5>
                        <table>
                            <tbody>
                                {channel
                                    .get('occupants')
                                    .map((occupant, occupantIndex) => {
                                        return (
                                            <tr key={`occupant_${occupantIndex}`}>
                                                <td>{occupant.get('uuid')}</td>
                                            </tr>
                                        );

                                    })}
                            </tbody>
                        </table>

                    </div>
                ));

            });
        }

        return (
            <div>
                {sections}
                <Footer/>
            </div>
        );
    }
}

TechAdminPage.propTypes = {
    user: PropTypes.object
};

function mapStateToProps(state) {
    return {
        workOrder: state.get('workOrder'),
        user: state.get('user'),
        techData: state.get('techData')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        workOrderActions: bindActionCreators(workOrderActions, dispatch),
        techInventoryActions: bindActionCreators(techInventoryActions, dispatch),
        statusActions: bindActionCreators(statusActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        push: bindActionCreators(dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TechAdminPage);


// WEBPACK FOOTER //
// ./src/containers/pages/TechAdminPage.js